var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9158_13587)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9158_13587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9158_13587)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9158_13587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9158_13587)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9158_13587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9158_13587)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9158_13587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9158_13587)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9158_13587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9158_13587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1653 13.167V19.1673H10.1659C9.90072 19.1673 9.64642 19.062 9.45892 18.8744C9.27142 18.6869 9.16602 18.4325 9.16602 18.1673V13.167H15.1653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1657 13.167V18.1673C19.1657 18.4325 19.0603 18.6869 18.8728 18.8744C18.6853 19.062 18.431 19.1673 18.1658 19.1673H16.166V13.167H19.1657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1649 10.167V12.1672H9.16602V10.167C9.16602 9.90182 9.27142 9.64745 9.45892 9.4599C9.64642 9.27235 9.90072 9.16699 10.1659 9.16699H18.165C18.4302 9.16699 18.6845 9.27235 18.872 9.4599C19.0596 9.64745 19.1649 9.90182 19.1649 10.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8284 6.17157C10.0783 5.42143 9.0609 5 8 5C6.93913 5 5.92172 5.42143 5.17157 6.17157C4.42143 6.92172 4 7.93913 4 9C4 10.0609 4.42143 11.0783 5.17157 11.8284C5.92172 12.5786 6.93913 13 8 13C8.52529 13 9.0454 12.8965 9.5307 12.6955C10.016 12.4945 10.457 12.1999 10.8284 11.8284C11.1999 11.457 11.4945 11.016 11.6955 10.5307C11.8965 10.0454 12 9.52529 12 9C12 8.47471 11.8965 7.95457 11.6955 7.46927C11.4945 6.98396 11.1999 6.54301 10.8284 6.17157ZM10.6719 9.32996C10.6736 9.35053 10.6712 9.37122 10.6648 9.39086C10.6585 9.4105 10.6483 9.42868 10.6349 9.44437C10.6215 9.46006 10.6051 9.47295 10.5867 9.48228C10.5683 9.49162 10.5482 9.49722 10.5276 9.49877H8.66452C8.62151 9.50165 8.581 9.52004 8.55052 9.55052C8.52004 9.581 8.50165 9.62151 8.49877 9.66452V11.5061C8.4959 11.5492 8.47751 11.5897 8.44703 11.6201C8.41655 11.6506 8.37604 11.669 8.33303 11.6719H7.66697C7.64681 11.6736 7.62651 11.6712 7.60724 11.665C7.58798 11.6588 7.57013 11.6489 7.55473 11.6358C7.53932 11.6227 7.52666 11.6066 7.51748 11.5886C7.5083 11.5705 7.50278 11.5509 7.50123 11.5307V9.66452C7.50247 9.64395 7.49965 9.62335 7.49291 9.60388C7.48617 9.58441 7.47566 9.56646 7.46197 9.55106C7.44829 9.53566 7.43169 9.52311 7.41315 9.51414C7.3946 9.50517 7.37447 9.49995 7.3539 9.49877H5.49079C5.46982 9.49959 5.4489 9.49627 5.42922 9.489C5.40954 9.48173 5.39149 9.47066 5.3761 9.4564C5.3607 9.44215 5.34827 9.425 5.33951 9.40594C5.33075 9.38687 5.32583 9.36627 5.32504 9.3453V8.6639C5.32784 8.62057 5.34611 8.57968 5.37654 8.54869C5.40696 8.5177 5.44751 8.49868 5.49079 8.49509H7.33241C7.35298 8.49677 7.37368 8.49436 7.39332 8.48801C7.41295 8.48165 7.43114 8.47148 7.44683 8.45807C7.46252 8.44466 7.4754 8.42829 7.48474 8.40988C7.49407 8.39148 7.49968 8.37141 7.50123 8.35083V6.51534C7.5041 6.47233 7.52249 6.43182 7.55297 6.40134C7.58345 6.37086 7.62396 6.35247 7.66697 6.3496H8.33303C8.37699 6.3496 8.41914 6.36706 8.45023 6.39814C8.48131 6.42923 8.49877 6.47138 8.49877 6.51534V8.35697C8.49709 8.37713 8.49942 8.39743 8.50562 8.4167C8.51182 8.43596 8.52176 8.45381 8.53489 8.46921C8.54801 8.48462 8.56405 8.49728 8.58208 8.50646C8.60012 8.51564 8.61979 8.52116 8.63997 8.52271H10.5061C10.5452 8.52557 10.5823 8.5408 10.6121 8.56619C10.6419 8.59158 10.6629 8.62581 10.6719 8.6639V9.32996Z",
    fill: "white"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9158_13587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDashboard);
export default __webpack_public_path__ + "static/media/add-dashboard.a3af289f05297202bf612770c3c7a00d.svg";
export { ForwardRef as ReactComponent };